export const Currency = {
  INR: '₹',
};
